export default __webpack_public_path__ + "static/media/six-sided-dice_too.3c6d9073.svg";